<template>
  <div class="card-add-result">
    <Succeed v-if="status === STATUS_MAP.success" />

    <Failed v-if="status === STATUS_MAP.failed" />
  </div>
</template>

<script>
import Succeed from './Succeed'
import Failed from './Failed'
import { query } from '@/api/card-add-result'
import { getCertificateLevel } from '@/store/modules/common/types'

const STATUS_MAP = Object.freeze({
  failed: 'failed',
  success: 'success'
})

export default {
  name: 'CardAddResult',

  components: {
    Succeed,
    Failed
  },

  data () {
    return {
      STATUS_MAP,
      status: null
    }
  },

  created () {
    this.queryPaymentResult()
  },

  methods: {
    // 查询绑卡结果
    queryPaymentResult () {
      // eslint-disable-next-line camelcase
      const { auth_token } = this.$route.query
      query({ authToken: auth_token })
        .then(result => {
          this.status = STATUS_MAP.success

          this.$store.dispatch(getCertificateLevel)
        })
        // 处理接口异常情况
        .catch(() => {
          this.status = STATUS_MAP.failed
          // this.confirmError()
        })
    }
  }
}
</script>

<style scoped lang="scss">
.card-add-result {
  padding: 100px 40px;
}
</style>
